// Central site content for MacWay Estate Services.
// Facts provided by the owner: brand name, phone, service area, services list.
// No statistics or numeric claims are used anywhere (owner request).

export const SITE = {
  name: "MacWay Estate Services",
  shortName: "MacWay",
  phone: "(301) 500-0128",
  phoneHref: "tel:+13015000128",
  email: "ron@macwayestateservices.com",
  emailHref: "mailto:ron@macwayestateservices.com",
  serviceArea: "DC, Maryland, and Virginia",
  headline: "Estate Sales, Cleanouts & Downsizing Made Easier",
};

export const IMAGES = {
  hero: "/images/hero.png",
  team1: "/images/donate-packing.png",
  team2: "/images/owner-portrait.png",
  estateSale: "/images/estate-sale.png",
  cleanout: "/images/cleanout-before-after.png",
  downsizing: "/images/sorting-client.png",
  packing: "/images/packing-prep.png",
  truckCurb: "/images/truck-curb.png",
  furnitureWrap: "/images/furniture-wrap.png",
};

export const SERVICES = [
  {
    slug: "estate-sales",
    name: "Estate Sales",
    short:
      "Full-service estate sales — sorting, staging, pricing, advertising, and hosting — handled with care from start to finish.",
    image: IMAGES.estateSale,
    link: "/services/estate-sales",
  },
  {
    slug: "estate-cleanouts",
    name: "Estate Cleanouts",
    short:
      "Complete, respectful cleanouts that leave the property empty, tidy, and ready for its next chapter.",
    image: IMAGES.cleanout,
    link: "/estate-cleanouts",
  },
  {
    slug: "downsizing",
    name: "Downsizing",
    short:
      "Patient, practical help sorting a lifetime of belongings when it's time to move to a smaller space.",
    image: IMAGES.downsizing,
    link: "/services/cleanouts-downsizing",
  },
  {
    slug: "packing-moving",
    name: "Packing & Moving Assistance",
    short:
      "Careful packing, move-day coordination, and settling-in help so the transition feels manageable.",
    image: IMAGES.packing,
    link: "/services",
  },
  {
    slug: "donation-pickup",
    name: "Donation Pickup & Furniture Removal",
    badge: "Paid Pickup & Removal Service",
    short:
      "We provide convenient pickup and removal of unwanted furniture, household items, and donations for a service fee. Pricing is based on the amount of items, labor required, and pickup location.",
    image: "/images/donation-pickup.png",
    link: "/services",
  },
  {
    slug: "decluttering",
    name: "Decluttering & Home Organization",
    short:
      "Room-by-room decluttering and simple organizing systems that make your home work for you again.",
    image: "/images/declutter-before-after.png",
    link: "/services",
  },
  {
    slug: "junk-removal",
    name: "Junk & Unwanted-Item Removal",
    short:
      "From a few bulky pieces to a whole house — we haul away what you no longer want, responsibly.",
    image: null,
    link: "/services",
  },
  {
    slug: "hoarding-assistance",
    name: "Hoarding Assistance",
    short:
      "Respectful, judgment-free help at your pace. We work alongside you and your family — never around you.",
    image: null,
    link: "/services",
  },
];

export const SERVICE_CHOICES = [
  "Estate Sale",
  "Estate Cleanout",
  "Downsizing",
  "Packing/Moving Assistance",
  "Donation Pickup & Furniture Removal",
  "Decluttering/Home Organization",
  "Junk Removal",
  "Hoarding Assistance",
  "Other",
];

export const REFERRAL_SOURCES = ["Estatesales.net", "Google", "Realtor", "Attorney", "Referral", "Other"];

export const CONTACT_METHODS = ["Phone", "Email", "Text"];

export const TIMEFRAMES = [
  "As soon as possible",
  "Within the next month",
  "1–3 months",
  "Flexible / just planning ahead",
];

export const PROCESS_STEPS = [
  {
    step: "1",
    title: "Reach out",
    text: "Call us or send a quote request. Tell us a little about the property and what you're facing — no preparation needed.",
  },
  {
    step: "2",
    title: "Walkthrough & written quote",
    text: "We visit, listen, and look at the scope together. You get a clear written quote with no pressure and no obligation.",
  },
  {
    step: "3",
    title: "We handle the work",
    text: "Our team takes care of the sorting, selling, hauling, and cleaning — and keeps you updated at every step.",
  },
];

export const WHO_WE_HELP = [
  {
    title: "Families settling an estate",
    text: "After a loss, the house full of belongings can feel like the hardest part. We take the logistics off your shoulders so you can focus on what matters.",
  },
  {
    title: "Homeowners downsizing or relocating",
    text: "Moving to a smaller home or out of the area? We help you decide what goes, what sells, and what gets donated — then make it happen.",
  },
  {
    title: "Executors, trustees & attorneys",
    text: "Reliable local hands for estate obligations: documented sales, timely cleanouts, and clear communication you can pass on to your clients.",
  },
  {
    title: "Real estate agents & their sellers",
    text: "Get listings market-ready fast — decluttering, cleanouts, and estate sales that keep your timeline on track and your sellers calm.",
  },
];
